import accountSaga from './account';
import bankCardSaga from './bankCard';
import passSaga from './pass';
import walletSaga from './wallet';
import { fork, put, call, takeLatest, all } from 'redux-saga/effects';
import app from '../../app';
import { loadOwnCompletion, setShareManagerUid } from '../../actions';

function* watchLoadOwn() {
  yield takeLatest('LOAD_OWN', function*() {
    const options = {
      url: '/api/getLoginVo',
      sync_server_time: true,
    };
    const result = yield call(app.httpFetch, options);

    if (result.error) {
      yield put(loadOwnCompletion(result.error));
      return;
    }

    const { loginCode } = result.data || {};
    let own = null;

    if (loginCode === 0) {
      own = result.data;

      /* if (app.track) {
        app.track.trackUser({ own });
      } */

      if (process.env.REACT_APP_UA) {
        const shareManagerUid = sessionStorage.getItem('SHARE-MANAGER');
        if (shareManagerUid) {
          yield put(setShareManagerUid(own && own.uid, shareManagerUid, 'web'));
        }
      } else if (app.env.ua) {
        const shareManagerUid = yield app.getStorage('SHARE-MANAGER');
        if (shareManagerUid) {
          yield put(setShareManagerUid(own && own.uid, shareManagerUid, 'wmp'));
        }
      }
    }

    yield put(loadOwnCompletion(undefined, loginCode, own));
  });
}

function* watchSetShareManagerUid() {
  yield takeLatest('SET_SHARE_MANAGER_UID', function* ({ uid, shareManagerUid, ua }) {
    if (!uid || !shareManagerUid || !ua) {
      return
    }

    const options = {
      url: '/api/user/sourceToCache',
      method: 'POST',
      data: {
        uid,
        managerUid: shareManagerUid
      }
    }

    const result = yield call(app.httpFetch, options);
    if (!result.error) {
      if (ua === 'web') {
        sessionStorage.removeItem('SHARE-MANAGER');
      } else if (ua === 'wmp') {
        app.setStorage('SHARE-MANAGER');
      }
    }
  })
}

export default function* ownSaga() {
  yield all([
    fork(accountSaga),
    fork(bankCardSaga),
    fork(passSaga),
    fork(walletSaga),
    fork(watchLoadOwn),
    fork(watchSetShareManagerUid)
  ]);
}
